// extracted by mini-css-extract-plugin
export default {"pageWrapper":"_404_pageWrapper__Ofb7I","container":"_404_container__QlHEb","Image_wrap":"_404_Image_wrap__evPYm","content":"_404_content__B-9Qm","nav":"_404_nav__k6ObI"};